<ng-container *transloco="let t">
    <div class="main-content">
        <us-breadcrumbs
            *ngrxLet="{ homePageUrl: homePageUrl$, productName: productStore.productName$ } as vm"
            [items]="[
                {
                    title: t('home'),
                    routerLink: vm.homePageUrl
                },
                {
                    title: vm.productName + '',
                    routerLink: undefined
                }
            ]"
        ></us-breadcrumbs>
        <section>
            <div class="grid lg:grid-cols-3 gap-4">
                <us-product-photo *ngIf="productStore.photos$ | async as photos" [photos]="photos"></us-product-photo>
                <div class="product-detail lg:col-span-2">
                    <div class="mb-2 flex gap-2 font-inter font-extrabold text-2xl text-black tracking-tight">
                        <h2 class="flex-auto">
                            {{ productStore.productName$ | async }}
                        </h2>
                        <p class="flex-none" *ngrxLet="productStore.selectedUnit$ as unit">
                            {{ unit?.price || 0 | formatCurrency }}
                        </p>
                    </div>

                    <div class="food-option">
                        <div class="food-option-title">
                            <p>{{ 'unit' | transloco }}</p>
                        </div>

                        <div
                            class="food-option-content"
                            *tuiLet="productStore.selectedUnitId$ | async as selectedUnitId"
                        >
                            <tui-radio-labeled
                                *ngFor="let unit of productStore.units$ | async"
                                [ngModel]="selectedUnitId"
                                (ngModelChange)="productStore.setUnitId($event)"
                                [item]="unit.id"
                                size="m"
                            >
                                <span>{{ unit.name + ' + ' + (unit.price | formatCurrency) }}</span>
                                <span
                                    *ngIf="unit.old_price !== null && unit.old_price > unit.price"
                                    class="text-gray-500 line-through ml-1"
                                >
                                    {{ unit.old_price | formatCurrency }}
                                </span>
                                <!--<span
                                class="badge badge-red"
                                *ngIf="product && product.discount_percent !== null && product.discount_percent > 0"
                            >
                                {{ '-' + product.discount_percent + '%' }}
                            </span>-->
                            </tui-radio-labeled>
                        </div>
                    </div>

                    <ng-container *ngFor="let option of productStore.options$ | async; let optionIndex = index">
                        <div class="food-option">
                            <div class="food-option-title">
                                <p>{{ option.title }}</p>
                                <span
                                    class="text-gray-500 text-sm"
                                    *ngIf="option.select_type === FoodOptionSelectType.AllowSelectedMultiple"
                                >
                                    {{ 'select_maximum' | transloco : { value: option.max_choose } }}
                                </span>
                            </div>

                            <div class="food-option-content">
                                <ng-container [ngSwitch]="option.select_type">
                                    <ng-container *ngSwitchCase="FoodOptionSelectType.NotAllowSelected">
                                        <tui-checkbox-labeled
                                            *ngFor="let item of option.items"
                                            [ngModel]="true"
                                            [readOnly]="true"
                                            size="m"
                                        >
                                            {{ item.name + ' + ' + (item.price | formatCurrency) }}
                                        </tui-checkbox-labeled>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="FoodOptionSelectType.AllowSelectedOne">
                                        <tui-radio-labeled
                                            *ngFor="let item of option.items"
                                            [ngModel]="option.selected_item"
                                            (ngModelChange)="productStore.setSelectedOptionItem({optionIndex, value: $event})"
                                            [item]="item"
                                            size="m"
                                            [identityMatcher]="optionItemIdentityMatcher"
                                        >
                                            {{
                                                item.name +
                                                    (item.price !== 0 ? ' + ' + (item.price | formatCurrency) : '')
                                            }}
                                        </tui-radio-labeled>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="FoodOptionSelectType.AllowSelectedMultiple">
                                        <tui-checkbox-labeled
                                            *ngFor="let item of option.items; let optionItemIndex = index"
                                            [ngModel]="item.selected"
                                            (ngModelChange)="productStore.toggleOptionItem({optionIndex, optionItemIndex})"
                                            size="m"
                                            [disabled]="!item.enabled"
                                        >
                                            <div class="flex items-center justify-between gap-1 whitespace-normal">
                                                <span>{{ item.name }}</span>
                                                <span *ngIf="item.price !== 0">+{{ item.price | formatCurrency }}</span>
                                            </div>
                                        </tui-checkbox-labeled>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngFor="let combo of productStore.comboList$ | async; let comboIndex = index">
                        <div class="food-option">
                            <div class="food-option-title">
                                <p>{{ combo.title }}</p>
                                <span
                                    class="text-gray-500 text-sm"
                                    *ngIf="combo.select_type === FoodOptionSelectType.AllowSelectedMultiple"
                                >
                                    {{ 'select_maximum' | transloco : { value: combo.max_choose } }}
                                </span>
                            </div>

                            <div class="food-option-content">
                                <ng-container [ngSwitch]="combo.select_type">
                                    <ng-container *ngSwitchCase="FoodOptionSelectType.NotAllowSelected">
                                        <tui-checkbox-labeled
                                            *ngFor="let item of combo.items"
                                            [ngModel]="true"
                                            [readOnly]="true"
                                            size="m"
                                        >
                                            {{ item.name }}
                                        </tui-checkbox-labeled>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="FoodOptionSelectType.AllowSelectedOne">
                                        <tui-radio-labeled
                                            *ngFor="let item of combo.items"
                                            [ngModel]="combo.selected_item"
                                            (ngModelChange)="productStore.setSelectedComboItem({comboIndex, value: $event})"
                                            [item]="item"
                                            size="m"
                                            [identityMatcher]="comboItemIdentityMatcher"
                                        >
                                            {{ item.name }}
                                        </tui-radio-labeled>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="FoodOptionSelectType.AllowSelectedMultiple">
                                        <tui-checkbox-labeled
                                            *ngFor="let item of combo.items; let comboItemIndex = index"
                                            [ngModel]="item.selected"
                                            (ngModelChange)="productStore.toggleComboItem({comboIndex, comboItemIndex})"
                                            size="m"
                                            [disabled]="!item.enabled"
                                        >
                                            <div class="flex items-center justify-between gap-1 whitespace-normal">
                                                {{ item.name }}
                                            </div>
                                        </tui-checkbox-labeled>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>

                    <div class="mt-4">
                        <div class="food-option-title">
                            <p>{{ 'quantity' | transloco }}</p>
                            <ng-container *tuiLet="productStore.quantityInStock$ | async as quantityInStock">
                                <p
                                    class="text-base text-gray-600"
                                    *ngIf="quantityInStock !== null && quantityInStock > 0"
                                >
                                    {{
                                        t('only_n_left', {
                                            value:
                                                quantityInStock / ((productStore.selectedUnit$ | async)?.ratio || 1)
                                                | floor
                                        }) +
                                            ' ' +
                                            ((productStore.selectedUnit$ | async)?.name || (t('product') | lowercase))
                                    }}
                                </p>
                            </ng-container>
                        </div>
                        <div class="flex justify-center">
                            <us-number-group
                                *tuiLet="productStore.quantity$ | async as quantity"
                                size="m"
                                [value]="quantity || 0"
                                (decreaseQuantityClick)="productStore.decreaseQuantity()"
                                (increaseQuantityClick)="productStore.increaseQuantity()"
                                [minimumQuantity]="(productStore.minimumQuantity$ | async) || 0"
                                [maximumQuantity]="
                                    ((productStore.maximumQuantity$ | async) || 0) /
                                        ((productStore.selectedUnit$ | async)?.ratio || 1) | floor
                                "
                            >
                            </us-number-group>
                        </div>
                    </div>
                    <div class="items-center justify-between py-8">
                        <tui-text-area
                            class="w-full min-h-[10rem]"
                            [ngModel]="productStore.note$ | async"
                            (ngModelChange)="productStore.setNote($event)"
                            [expandable]="true"
                            [maxLength]="100"
                        >
                            {{ 'add_messages_to_the_store' | transloco }}
                            <textarea tuiTextfield maxlength="100"></textarea>
                        </tui-text-area>
                    </div>
                </div>
            </div>
            <div class="mt-8 bg-neutral-100 p-4" *ngIf="productStore.productDescription$ | async as description">
                <h3>{{ 'product_description' | transloco }}</h3>
                <div class="product-description" [innerHTML]="description || ''"></div>
            </div>
        </section>
    </div>

    <div class="sticky lg:static bottom-0 z-30 bg-white shadow lg:shadow-none py-2 px-4">
        <div class="container mx-auto">
            <ng-container
                *ngrxLet="{
                    disabled: disabledAddToCart$,
                    available: productStore.productAvailable$,
                    total: productStore.totalPrice$,
                    quantity: productStore.quantity$,
                    shop: shopCurrent$
                } as vm"

            >
                <button

                    tuiButton
                    type="button"
                    appearance="primary"
                    size="m"
                    [disabled]="vm.disabled || found_time"
                    *ngrxLet="homePageUrl$ as homePageUrl"
                    (click)="productStore.addToCart({ redirectUrl: homePageUrl + '?pageYOffset='+pageYOffset+''  })"
                    class="w-full"
                >
                    @if(found_time) {
                        {{ t('shop_closed_time', { value: (vm.shop | openTimeToDayV2 | async) ?? '' }) }}
                    } @else if (vm.available && ((quantityInStock$ | async) || 0) !== 0) {
                        {{ t('add_to_cart')}}
                    } @else {
                        {{ t('sold') + ' - ' + (vm.total * vm.quantity | formatCurrency)}}
                    }
                </button>
                <!--<div class="w-full flex gap-2 lg:justify-end">
                    <button
                        tuiButton
                        type="button"
                        appearance="primary"
                        size="m"
                        class="ml-2"
                        (click)="productStore.addToCart({ checkout: true })"
                        [disabled]="disabled || false"
                        *tuiLet="productStore.productAvailable$ | async as available"
                        class="w-max flex-auto lg:flex-none"
                    >
                        {{ available ? t('buy_now') : t('sold') }}
                    </button>
                </div>-->
            </ng-container>
        </div>
    </div>
</ng-container>
